import React from "react";
import { Controller } from "react-hook-form";
import { SettingsInput } from "./SettingsInput";

export interface ControlledInputProps {
  control: any;
  name: string;
  label: string;
  placeholder?: string;
  defaultValue?: string;
  rules?: Record<string, any>;
}

const ControlledInput: React.FC<ControlledInputProps> = ({
  control,
  name,
  label,
  placeholder,
  defaultValue = "",
  rules = {},
}) => (
  <Controller
    control={control}
    name={name}
    defaultValue={defaultValue}
    rules={rules}
    render={({ field: { value, onChange }, fieldState: { error } }) => (
      <div>
        <SettingsInput
          value={value}
          isError={!!error}
          onChange={(e) => onChange(e.target.value)}
          label={label}
          placeholder={placeholder}
          inputClasses={"w-full"}
        />
        <FieldErrorText message={error?.message} />
      </div>
    )}
  />
);

/**
 * The rule's message under a field (QA batch 11: Settings > Firm details showed
 * only a red border for an empty name or a bad email).
 */
export const FieldErrorText: React.FC<{ message?: string }> = ({ message }) =>
  message ? (
    <span role={"alert"} className={"mt-1 block text-sm text-red-500"}>
      {message}
    </span>
  ) : null;

export default ControlledInput;
